<template>
  <div class="members-table">
    <table class="table table-responsive">
      <thead>
        <tr :class="`bg-${module}`">
          <th>Nom</th>
          <th>Emails</th>
          <th v-for="p in permissions"
              class="text-center"
              :key="`${p.key}-header`">{{ p.short }}</th>
          <th v-if="admin">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in members"
            :key="m.id">
          <td :id="`n-${m.id}`">
            {{ m.firstName }} {{ m.name }}
            <span v-if="m.identity !== ''">
              <br><small><i>{{ m.identity }}</i></small>
            </span>
          </td>
          <td :id="`e-${m.id}`">{{ m.emails }}</td>
          <td v-for="p in permissions"
              class="text-center"
              :key="`${m.id}-${p.key}`">
            <c-checkbox v-if="p.key == 'results' && module !== 'observa4'"
                        :type="module"
                        :disabled="m.disabled"
                        empty
                        size="sm"
                        @click.prevent.native="askForUncheck(m, p.key)"
                        v-model="m.perm[p.key]"></c-checkbox>
            <c-checkbox v-else
                        :type="module"
                        :disabled="m.disabled"
                        empty
                        size="sm"
                        @click.prevent.native="togglePermission(m, p.key)"
                        v-model="m.perm[p.key]"></c-checkbox>
          </td>
          <td v-if="admin">
            <a v-if="!m.disabled"
               role="button" @click="askForRemoval(m)">
              Supprimer
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row" v-if="admin">
      <div class="col-xs-12">
        <slot name="default"><h3>Ajouter un membre</h3></slot>
      </div>
      <div class="col-xs-12 col-md-8 col-lg-6">
        <form class="form">
          <div class="form-group">
            <h4 class="control-label">Adresse e-mail</h4>
            <input placeholder="Adresse e-mail de l'utilisateur"
                   id="email"
                   class="form-control"
                   v-model.trim="add.userEmail"
                   required >
          </div>
          <h4 v-if="permissions.length > 1">
            Permissions
          </h4>
          <alert type="warning" v-if="permissions.length > 1">
            <p class="text-justify">
              Sélectionner ci-dessous les actions autorisées pour cet
              utilisateur. Une fois l'utilisateur ajouté, vous pourrez changer
              ses permissions à tout moment en utilisant le tableau situé en
              haut de cette page.
            </p>
          </alert>
          <div v-for="p in permissions"
               :key="`${p.key}-perm`">
            <span>
              <div class="panel panel-default"
                   role="button"
                   @click.prevent="add.permissions[p.key] = !add.permissions[p.key]">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-xs-10">
                      <h4>{{p.short}}</h4>
                      <p v-html="p.label"></p>
                      <div v-if="!isResultsModule && p.key == 'results' && module !== 'observa4'">
                        <alert type="warning" class="text-justify">
                          <p>
                            L'accès complet aux résultats utilise
                            des <strong>DONNÉES DE SANTÉ</strong>. Cet accès
                            est réservé aux personnels médicaux.
                          </p>
                        </alert>
                      </div>
                    </div>
                    <div class="col-xs-2 text-center">
                      <c-checkbox v-if="!isResultsModule && p.key == 'results'"
                          :type="module"
                          :cboxclass="`checkbox-${p.key}`"
                          empty
                          size="sm"
                          @click.native.prevent.stop.capture="askForUncheck(null, p.key)"
                          v-model="add.permissions[p.key]">
                      </c-checkbox>
                      <c-checkbox v-else
                          :type="module"
                          empty
                          size="sm"
                          v-model="add.permissions[p.key]">
                      </c-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <div class="error-container">
            <collapse v-model="showAlert">
              <alert :type="add.alert.type" class="text-justify">
                <h4 class="txt-white">{{ add.alert.title }}</h4>
                <p v-html="add.alert.text"></p>
              </alert>
            </collapse>
          </div>
          <btn type="default" @click.stop="addMember">Ajouter</btn>
        </form>
      </div>
    </div>
    <modal v-model="removeModal"
           @hide="removeModalEnded"
           title="Confirmation"
           :append-to-body="nested"
           ok-text="Oui" cancel-text="Non"
           ok-type="danger" cancel-type="primary">
      <p v-if="removeModal">
        Êtes vous certain.e de vouloir retirer
        <strong>
          {{ remove.referent.firstName }} {{ remove.referent.name }}
        </strong> des membres de la modalité ?
      </p>
    </modal>
    <modal v-model="resultsModal"
           @hide="resultsModalEnded"
           title="Confirmation"
           :append-to-body="nested"
           ok-text="Oui" cancel-text="Non"
           ok-type="danger" cancel-type="primary">
      <p>
        L'accès complet aux résultats utilise des
        <strong>DONNÉES DE SANTÉ</strong>.
      </p>
      <p>
        Cet accès est réservé aux personnels médicaux.
      </p>
      <div v-if="resultsModal && resultsTarget.member">
        <p>
          Êtes-vous certain.e de vouloir accorder cet accès à
          <strong>
          {{ resultsTarget.member.firstName }} {{ resultsTarget.member.name }}
          </strong> ?
        </p>
      </div>
      <div v-else>
        <p>
          Êtes-vous certain.e de vouloir accorder cet accès ?
        </p>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import go from '@/gojs/go'

import checkbox from '@/sui/components/checkbox'
import tools from '@/sui/tools/main'

const errors = {
  std: `Si le problème persiste, contactez-nous via le formulaire de contact.`,
  net: `Une erreur s'est produite lors de la connexion au serveur, merci de
vérifier votre connexion internet avant de réessayer. Si le problème persiste,
contactez-nous via le formulaire de contact.`
}

export default {
  name: 'members-table',

  props: {
    module: {
      type: String,
      required: true
    },

    surveillance: {
      type: Object,
      required: true
    },

    nested: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'c-checkbox': checkbox
  },

  data: function () {
    const resetPermissions = function (permissions) {
      const result = {}
      permissions.forEach(p => { result[p.key] = false })
      return result
    }

    const write = {
      key: 'write',
      value: go.perm.p.EditSheets,
      label: `Saisie, modification et
suppression des fiches.`,
      short: 'Saisie'
    }

    const valid = {
      key: 'valid',
      value: go.perm.p.ValidateSheets,
      label: `Validation des fiches et envoi des données au programme
national.`,
      short: 'Validation'
    }

    const members = {
      key: 'members',
      value: go.perm.p.ManageMembers,
      label: `Ajout, suppression et choix des permissions des membres
de ce module.`,
      short: 'Membres'
    }

    const permissions = {
      def: [
        write,
        valid,
        {
          key: 'results',
          value: go.perm.p.GetStatistics,
          label: `Accès aux taux d'incidences, graphiques et caractéristiques
calculés à partir de cette modalité.`,
          short: 'Résultats'
        },
        members
      ],

      observa4: [
        write,
        valid,
        {
          key: 'results',
          value: go.perm.p.GetStatistics,
          label: `Accès aux résultats.`,
          short: 'Résultats'
        },
        members
      ],

      results: [
        {
          key: 'results',
          value: go.perm.p.GetStatistics,
          label: `Accès aux incidences de tout l'établissement.`,
          short: 'Résultats'
        }
      ]
    }

    const p = permissions[this.module]
    const perm = p == null ? permissions.def : p

    return {
      permissions: perm,
      add: {
        alert: { type: '', text: '', title: '' },
        userEmail: null,
        permissions: resetPermissions(perm)
      },
      remove: {
        referent: null
      },
      removeModal: false,
      resultsModal: false,
      resultsTarget: {
        member: null,
        key: null
      },
      resetPermissions: resetPermissions
    }
  },

  computed: {
    ...mapGetters({
      userId: 'user/id'
    }),

    admin: function () {
      return this.surveillance.canManageMembers(this.userId, this.module)
    },

    showAlert: function (t) {
      const { alert } = this.add
      return alert.text !== '' || alert.title !== ''
    },

    isResultsModule: function () {
      return this.module === 'results'
    },

    members: function () {
      const vm = this
      if (!this.surveillance.hasProtocol(this.module)) {
        return []
      }
      const result = []
      const members = this.surveillance.modules[this.module].members
      for (let j in members) {
        const r = members[j]
        const perm = {}
        this.permissions.forEach(
          p => {
            perm[p.key] = r.perm == null ||
                          (r.perm[go.units.allUfKey] != null &&
                           r.perm[go.units.allUfKey].indexOf(p.value) !== -1)
          }
        )

        const me = r.user.id === this.userId
        const referent = this.surveillance.isRegistrator(r.user.id)
        const identity = referent ? 'Responsable' : ''

        result.push({
          ref: r,
          disabled: !this.admin || r.perm == null || me,
          perm: perm,
          identity: identity,
          id: r.user.id,
          name: r.user.name,
          firstName: r.user.firstName,
          emails: this.displayEmails(r.user.emails)
        })
      }

      return result.sort((first, second) => {
        const ref = vm.surveillance.registrator.id
        const me = this.userId
        if (first.id === ref) {
          return -1
        } else if (second.id === ref) {
          return 1
        }
        if (first.id === me) {
          return -1
        } else if (second.id === me) {
          return 1
        }
        const firstName = `${first.name} ${first.firstName}`
        const secondName = `${second.name} ${second.firstName}`
        return firstName.localeCompare(secondName)
      })
    }
  },

  methods: {
    setAlert: function (type, text, title) {
      this.add.alert.type = type
      this.add.alert.text = text
      this.add.alert.title = title
    },

    resetAlert: function () {
      this.add.alert.type = ''
      this.add.alert.text = ''
      this.add.alert.title = ''
    },

    setError: function (text, title) {
      this.setAlert('danger', text, title)
    },

    setWarning: function (text, title) {
      this.setAlert('warning', text, title)
    },

    setSuccess: function (text, title) {
      this.setAlert('info', text, title)
    },

    buildPermissions: function (perm) {
      const result = [4]
      this.permissions.forEach(
        p => {
          if (perm[p.key] === true) {
            result.push(p.value)
          }
        }
      )
      return result
    },

    addMember: function () {
      this.resetAlert()
      const { userEmail, permissions } = this.add

      if (userEmail == null || !tools.isEmailValid(userEmail)) {
        this.setError(
          'Veuillez entrer une adresse e-mail valide.',
          'Adresse e-mail invalide !'
        )
        return
      }

      const emails = this.surveillance.registrator.emails
      const isRegistrator = emails.find(em => em === userEmail) != null
      if (isRegistrator) {
        this.setError(
          'Veuillez entrer une adresse e-mail valide.',
          `L'adresse e-mail est celle du responsable du programme !`
        )
        return
      }

      if (this.isResultsModule) {
        for (let m in this.surveillance.modules) {
          if (m === 'results') {
            continue
          }

          const mod = this.surveillance.modules[m]
          if (mod.members == null) {
            continue
          }

          const isMember = mod.members.find(
            e => e.user.emails.find(em => em === userEmail) != null
          )
          if (isMember) {
            this.setError(
              `Les droits d'accès aux résultats des membres de la surveillance
sont ajoutés directement depuis la page «Membres» des différentes modalités.`,
              `L'adresse e-mail est celle d'un membre de la surveillance !`
            )
            return
          }
        }
      } else {
        const mod = this.surveillance.modules.results
        if (mod != null) {
          const isMember = mod.members.find(
            e => e.user.emails.find(em => em === userEmail) != null
          )
          if (isMember) {
            this.setError(
              `Une personne ne peut pas être à la fois membre de la surveillance
et destinataire des résultats. N'hésitez pas à nous écrire via le formulaire de
contact si vous ne parvenez pas à définir les droits d'accès souhaités.`,
              `L'adresse e-mail est celle d'un destinataire des résultats !`
            )
            return
          }
        }
      }

      const perm = this.buildPermissions(permissions)
      if (perm.length === 1) {
        this.setError(
          'Veuillez cocher au moins une permission.',
          'Permissions invalides'
        )
        return
      }

      const ufp = {}
      ufp[go.units.allUfKey] = perm
      let request = {
        surv: this.surveillance.id,
        email: userEmail,
        perm: ufp,
        mod: this.module
      }
      const vm = this
      this.$store.dispatch(`surveillances/addMember`, request).then(
        (response) => {
          if (response.data.err == null) {
            switch (response.data.v) {
              case 2: // Ghost User
                vm.$notify({
                  type: 'success',
                  title: `${request.email} a bien été ajouté.e en tant que
membre de la surveillance !`,
                  duration: 10000
                })
                break
              case 1: // Valid User
                vm.$notify({
                  type: 'success',
                  duration: 10000,
                  title: `${request.email} a bien été ajouté.e en tant que
membre de la surveillance.`
                })
                break
            }
            vm.add.userEmail = null
            vm.add.permissions = vm.resetPermissions(vm.permissions)
          } else if (response.data.err === '[UnknownUser]') {
            vm.setWarning(
              `Une fois que la personne aura suivi la procédure d'ouverture
de compte, vous pourrez l'ajouter comme membre
de la surveillance en utilisant à nouveau ce formulaire.`,
              `${request.email} n'a pas pu être ajouté aux membres de
cette surveillance car aucun compte utilisateur enregistré n'utilise cette
adresse e-mail.`
            )
          } else {
            vm.setError(
              `${errors.std}`,
              `Impossible d'ajouter ${request.email} en tant que membre de
la surveillance.`
            )
          }
        }).catch(
        function (e) {
          vm.setError(
            `${errors.net}`,
            `Impossible d'ajouter ${request.email} en tant que membre de
la surveillance.`
          )
        })
    },

    togglePermission: function (m, key) {
      if (m.disabled) {
        return
      }

      const toggle = () => { m.perm[key] = !m.perm[key] }
      toggle()

      const perm = this.buildPermissions(m.perm)
      if (perm.length === 1) {
        this.$notify({
          type: 'danger',
          title: 'Permissions invalides',
          content: `Vous devez sélectionner au moins une permission. Si vous
souhaitez retirer les droits d'un utilisateur, cliquez sur le bouton
«Supprimer».`,
          duration: 100000
        })
        toggle()
        return
      }

      const u = m.ref.user
      const ufp = {}
      ufp[go.units.allUfKey] = perm
      const request = {
        surv: this.surveillance.id,
        user: u.id,
        mod: this.module,
        perm: ufp
      }

      const vm = this
      this.$store.dispatch(`surveillances/updateMember`, request).then(
        (response) => {
          if (response.data.err == null) {
            vm.$notify({
              type: 'success',
              title: `Les permissions de ${u.firstName} ${u.name} ont été
modifiées avec succès !`,
              duration: 10000,
              content: ``
            })
          } else {
            vm.$notify({
              type: 'danger',
              title: `Impossible de modifier les permissions de ${u.firstName}
${u.name} !`,
              duration: 0,
              content: `${errors.std}`
            })
            toggle()
          }
        }).catch(function (e) {
        vm.$notify({
          type: 'danger',
          title: `Impossible de modifier les permissions de ${u.firstName}
${u.name} !`,
          duration: 0,
          content: `${errors.net}`
        })
        toggle()
      })
    },

    displayEmails (l) {
      return l.join(', ')
    },

    askForRemoval: function (r) {
      this.removeModal = true
      this.remove.referent = r
    },

    askForUncheck: function (m, key) {
      if (m != null) {
        if (m.perm[key]) {
          this.togglePermission(m, key)
        } else {
          this.resultsModal = true
          this.resultsTarget.member = m
          this.resultsTarget.key = key
        }
      } else if (!this.add.permissions[key]) {
        this.resultsModal = true
        this.resultsTarget.key = key
      } else {
        this.add.permissions[key] = false
      }
    },

    removeModalEnded: function (msg) {
      if (msg === 'ok') {
        this.removeMember(this.remove.referent)
      }
      this.remove.referent = null
      this.remove.type = null
    },

    resultsModalEnded: function (msg) {
      if (this.resultsTarget.member) {
        if (msg === 'ok') {
          this.togglePermission(this.resultsTarget.member, this.resultsTarget.key)
        }
        this.resultsTarget.member = null
        this.resultsTarget.key = null
      } else {
        if (msg === 'ok') {
          this.add.permissions[this.resultsTarget.key] = true
        }
      }
    },

    removeMember (u) {
      let request = {
        surv: this.surveillance.id,
        user: u.id,
        mod: this.module
      }
      let instance = this
      this.$store.dispatch(`surveillances/removeMember`, request).then(
        (response) => {
          if (response.data.err == null) {
            instance.$notify({
              type: 'success',
              title: 'Succès !',
              content: `${u.firstName} ${u.name} a bien été retiré des membres
de cette modalité.`
            })
          } else {
            instance.$notify({
              type: 'danger',
              title: `Impossible de retirer ${u.firstName} ${u.name} des
membres de la modalité !`,
              duration: 0,
              content: `${errors.std}`
            })
          }
        }).catch(function (e) {
        instance.$notify({
          type: 'danger',
          title: `Impossible de retirer ${u.firstName} ${u.name} des
membres de la modalité !`,
          duration: 0,
          content: `${errors.net}`
        })
      })
    }

  }
}
</script>
<style scoped lang="less">
@import '~variables';

.members-table {
  color: @base-text;
  a:hover {
    cursor: pointer;
  }

  .form-checkbox {
    vertical-align: text-top;
  }

  .control-label {
    margin-right: 1rem;
    font-weight: normal;
  }

  h3 {
    margin-top: 4rem;
  }

  .table {
    margin-bottom: 0rem;
  }

  tr {
    border-radius: 2px;
  }

  .error-container {
    margin-top: 2rem;
  }

  .panel-body h4 {
    margin-top: 0rem;
  }
}

form {
  .btn {
    margin-bottom: 2rem;
  }
}

.alert-danger h4 {
  color: white;
}

</style>
